<template>
  <div class="slfns--container no-select">
    <div
        v-for="cat in list"
        :key="cat.id"
        class="slfns--cat"
    >
      <div class="slfns--cat-name">
        <div @click="toggleCheckCategory(cat.id)">
          <div>
            <f-awesome icon="hand-pointer"></f-awesome>
          </div>
        </div>
        <div @click="toggleShowServices(cat.id)">{{cat.name}}</div>
        <div @click="toggleShowServices(cat.id)">
          <f-awesome
              v-show="cat.showServices"
              icon="angle-up"
          ></f-awesome>
          <f-awesome
              v-show="!cat.showServices"
              icon="angle-down"
          ></f-awesome>
        </div>
      </div>
      <div v-if="cat.showServices == true" class="slfns--serv-container">
        <div
            v-for="serv in cat.services"
            :key="serv.id"
            class="slfns--serv"
        >
          <div v-if="serv.subcategory == 0" class="slfns--serv-select">
            <input @click="toggleCheckService(serv.id)" type="checkbox" v-model="serv.checked">
            <span @click="toggleCheckService(serv.id)">{{serv.name}}</span>
          </div>
          <div v-if="serv.subcategory == 1" class="slfns--serv-subcat">
            <div class="slfns--subcat-name">
              <div @click="toggleCheckSubcategory(serv.id)">
                <div>
                  <f-awesome icon="hand-pointer"></f-awesome>
                </div>
              </div>
              <div @click="toggleShowModifications(serv.id)">{{serv.name}}</div>
              <div @click="toggleShowModifications(serv.id)">
                <f-awesome
                    v-show="serv.showModified"
                    icon="angle-up"
                ></f-awesome>
                <f-awesome
                    v-show="!serv.showModified"
                    icon="angle-down"
                ></f-awesome>
              </div>
            </div>
            <div v-if="serv.showModified" class="slfns--modifications-container">
              <div
                  v-for="modif in serv.modification"
                  :key="modif.id"
                  class="slfns--modifications"
              >
                <div class="slfns--modification-name">
                  <input @click="toggleCheckModification(modif.id)" type="checkbox" v-model="modif.checked">
                  <span @click="toggleCheckModification(modif.id)">{{modif.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ServiceListForNewStaff",
  components: {},
  data() {
    return {
      list: []
    };
  },
  props: {
    data: Array,
    defaultServices: Array,
    defaultModifications: Array,
    reset: Number
  },
  watch: {
    reset: function(){
      for(let cat in this.list){
        for(let serv in this.list[cat].services){
          this.$set(this.list[cat].services[serv], "checked", false);
          for(let modif in this.list[cat].services[serv].modification){
            this.$set(this.list[cat].services[serv].modification[modif], "checked", false);
          }
        }
      }
    },
    data: function(val){
      this.filterDataCatList(val);
    },
    defaultServices: function(val){
      for(let defServ in val){
        for(let cat in this.list){
          for(let serv in this.list[cat].services){
            if(+val[defServ] === +this.list[cat].services[serv].id){
              this.$set(this.list[cat].services[serv], "checked", true);
            }
          }
        }
      }
      this.emitList();
    },
    defaultModifications: function(val){
      for(let defModif in val){
        for(let cat in this.list){
          for(let serv in this.list[cat].services){
            for(let modif in this.list[cat].services[serv].modification){
              if(+val[defModif] === +this.list[cat].services[serv].modification[modif].id){
                this.$set(this.list[cat].services[serv].modification[modif], "checked", true);
              }
            }
          }
        }
      }
      this.emitList();
    },
  },
  computed: {

  },
  methods: {
    toggleShowServices(catId){
      for(let cat in this.list){
        if(+catId === +this.list[cat].id){
          this.$set(this.list[cat], "showServices", !this.list[cat].showServices);
        }
      }
    },
    toggleShowModifications(subcatId){
      for(let cat in this.list){
        for(let serv in this.list[cat].services){
          if(+subcatId === +this.list[cat].services[serv].id && +this.list[cat].services[serv].subcategory === 1){
            this.$set(this.list[cat].services[serv], "showModified", !this.list[cat].services[serv].showModified);
          }
        }
      }
    },
    toggleCheckService(servId){
      for(let cat in this.list){
        for(let serv in this.list[cat].services){
          if(+servId === +this.list[cat].services[serv].id){
            this.$set(this.list[cat].services[serv], "checked", !this.list[cat].services[serv].checked);
          }
        }
      }
      this.emitList();
    },
    toggleCheckCategory(catId){
      let firstChecked = false;
      for(let cat in this.list){
        if(+catId === +this.list[cat].id){
          if(this.list[cat].services.length){
            for(let firstKey in this.list[cat].services){
              if(+this.list[cat].services[firstKey].subcategory === 0){
                firstChecked = !this.list[cat].services[firstKey].checked;
                break;
              }
            }
          }
          for(let serv in this.list[cat].services){
            if(+this.list[cat].services[serv].subcategory === 0){
              this.$set(this.list[cat].services[serv], "checked", firstChecked);
            }
            for(let modif in this.list[cat].services[serv].modification){
              this.$set(this.list[cat].services[serv].modification[modif], "checked", firstChecked);
            }
          }
        }
      }
      this.emitList();
    },
    toggleCheckSubcategory(servId){
      let firstChecked = false;
      for(let cat in this.list){
        for(let serv in this.list[cat].services){

          if(+this.list[cat].services[serv].id === +servId){
            if(this.list[cat].services[serv].modification.length){
              firstChecked = !this.list[cat].services[serv].modification[0].checked;
            }
            for(let modif in this.list[cat].services[serv].modification){
              this.$set(this.list[cat].services[serv].modification[modif], "checked", firstChecked);
            }
          }

        }
      }
      this.emitList();
    },
    toggleCheckModification(modifId){
      for(let cat in this.list){
        for(let serv in this.list[cat].services){
          for(let modif in this.list[cat].services[serv].modification){
            if(+modifId === +this.list[cat].services[serv].modification[modif].id){
              this.$set(this.list[cat].services[serv].modification[modif], "checked", !this.list[cat].services[serv].modification[modif].checked);
            }
          }
        }
      }
      this.emitList();
    },
    emitList(){
      let result = {
        selectedServices: [],
        selectedModifications: []
      };
      for(let cat in this.list){
        for(let serv in this.list[cat].services){
          if(this.list[cat].services[serv].checked){
            result.selectedServices.push(this.list[cat].services[serv].id);
          }
          for(let modif in this.list[cat].services[serv].modification){
            if(this.list[cat].services[serv].modification[modif].checked){
              result.selectedModifications.push(this.list[cat].services[serv].modification[modif].id);
            }
          }
        }
      }
      this.$emit('checked', result);
    },
    filterDataCatList(data){
      this.list = data;
      for(let cat in this.list){
        this.$set(this.list[cat], "showServices", true);
        for(let serv in this.list[cat].services){
          this.$set(this.list[cat].services[serv], "checked", false);
          this.$set(this.list[cat].services[serv], "showModified", true);
          for(let modif in this.list[cat].services[serv].modification){
            this.$set(this.list[cat].services[serv].modification[modif], "checked", false);
          }
        }
      }
    }
  },
};
</script>

<style scoped lang="less">
.slfns--cat-name{
  padding: 7px;
  margin-top: 4px;
  background-color: #7FA1CA;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  &>div:nth-of-type(1){
    text-align: center;
    width: 30px;
    font-size: 15px;
  }
  &>div:nth-of-type(2){
    width: 75%;
  }
  &>div:nth-of-type(3){
    width: 10%;
  }
}
.slfns--subcat-name{
  padding: 7px;
  background-color: #7FA1CA;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  &>div:nth-of-type(1){
    text-align: center;
    width: 30px;
    font-size: 15px;
  }
  &>div:nth-of-type(2){
    width: 75%;
  }
  &>div:nth-of-type(3){
    width: 10%;
  }
}
.slfns--serv{
  padding-left: 20px;
  margin: 8px 0;
  cursor: pointer;
}
.slfns--modifications{
  padding-left: 20px;
}
.slfns--modification-name{
  padding: 7px;
  border-radius: 8px;
  margin: 8px 0;
  background-color: #F0F4F9;
  cursor: pointer;
}
.slfns--serv-select{
  padding: 7px;
  border-radius: 8px;
  background-color: #F0F4F9;
}
//#F0F4F9
</style>
